import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/Services/auth.service';
import { TokenService } from 'src/app/Services/token.service';
import { UserService } from 'src/app/Services/user.service';
import * as myGlobals from '../../app.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  user: User;
  public userImage = 'assets/img/users/user.jpg';
  public loggedIn: boolean;
  role: any;
  fileName: any;
  baseUrl = myGlobals.baseFileUrl;

  constructor(
    private token: TokenService,
    private auth: AuthService,
    public router: Router,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.auth.authStatus.subscribe((value) => (this.loggedIn = value));

    // * get the user details
    this.userService.getUser({}).then(user => {
      this.user = user
    });
    this.userService.getUserId().subscribe(data => {
      this.role = data['user']['role']
      if (this.role) {
        this.userService.getGuidelines(this.role).subscribe(data => {
          this.fileName = data['file']
          this.baseUrl = this.baseUrl + "/" + this.fileName;
        });
      }
    });

  }

  logout() {
    localStorage.removeItem('departmentId');
    this.token.remove();
    this.auth.changeStatus(false);
    this.router.navigateByUrl('/login');
  }
  grievance(){
    this.router.navigateByUrl('/grievanceTable');
  }
}
